import React, { FunctionComponent, useMemo } from 'react';
import PageBreadcrumbs, { BreadcrumbItem } from '@modules/ui/shared/components/PageBreadcrumbs';
import { useTranslation } from '@rbx/intl';
import useResponsiveDesign from '@modules/miscellaneous/common/hooks/useResponsiveDesign';

export type TAppIAHeadingProps = {
  breadcrumbsItems?: BreadcrumbItem[] | null;
  title?: string;
};

const AppIAHeading: FunctionComponent<TAppIAHeadingProps> = ({ breadcrumbsItems, title }) => {
  const { translate } = useTranslation();

  const hasBreadcrumbs = useMemo(
    () => breadcrumbsItems && breadcrumbsItems.length,
    [breadcrumbsItems],
  );

  const { isMobile } = useResponsiveDesign();
  if (isMobile) {
    return <span>{translate('Heading.Learn')}</span>;
  }

  return hasBreadcrumbs ? (
    <PageBreadcrumbs items={breadcrumbsItems || []} enableNewLayout />
  ) : (
    <span>{title || translate('Heading.Learn')}</span>
  );
};

export default AppIAHeading;
